( ( $ ) => {
	let FlexibleBundles = {};
	const $cartItems = $( '.js-cart-items' ),
		isSinglePage = $( 'body' ).hasClass( 'single-silk_products' );

	FlexibleBundles.changeColor = () => {
		if ( isSinglePage ) {
			$( '.js-color-item-checkbox' ).change( ( e ) => {
				$( '#js-images-' + e.currentTarget.dataset.section )
					.find( '.product-bundle-item-image' )
					.each( ( index, image ) => {
						if ( image.dataset.color != e.currentTarget.value ) {
							image.style.display = 'none';
						} else {
							image.style.display = 'initial';
						}
					} )
					.end()
					.flickity( 'resize' );

				$( '#js-sizes-' + e.currentTarget.dataset.section + ' .js-size-list-item' )
					.each( ( index, item ) => {
						if ( item.dataset.color != e.currentTarget.value ) {
							item.style.display = 'none';
						} else {
							item.style.display = 'initial';
						}
					} );

				$( '#js-sizes-' + e.currentTarget.dataset.section + ' input[type=radio]' )
					.prop( 'checked', false );
			} );
		} else {
			$( '.js-section-color' ).change( ( e ) => {
				const section = e.currentTarget.dataset.section,
					$select = $( 'select#section-' + section + '-size' ),
					$selected = $( 'input[name=section-' + section + '-color]:checked' );

				$select.find( 'option' )
					.hide()
					.end()
					.find( 'option[data-color=' + $selected.val() + ']' )
					.show()
					.end()
					.find( 'option[data-color=' + $selected.val() + ']' )
					.not( ':disabled' )
					.first()
					.prop( 'selected', true );
			} );
		}
	};

	FlexibleBundles.removeBundle = () => {
		$( document ).on( 'click', '.js-remove-bundle', ( e ) => {
			e.preventDefault();

			const $element = $( e.currentTarget ),
				isCheckout = $element.data( 'checkout' );

			$.ajax( {
				url: window.ajaxURL,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'remove_bundle',
					line: $element.data( 'line' ),
					checkout: isCheckout,
				},
				beforeSend: () => {
					if ( isCheckout ) {
						window.Checkout.showLoader( true );
					} else {
						$element.parents( 'li.item' ).addClass( 'is-processing' );
					}
				},
				error: ( data, textStatus ) => {
					console.log( data );
					console.log( textStatus );
				},
				success: ( result ) => {
					if ( isCheckout ) {
						if ( result.totalItems === 0 || result.items === '' ) {
							window.location.href = location.pathname;
						} else {
							window.Checkout.updateHtml( result );
						}
					} else {
						if ( result.success && result.data.cart ) {
							$cartItems.html( result.data.cart );
							window.Cart.toggleCart( 'open' );
						}
					}
				},
				complete: () => {
					if ( isCheckout ) {
						window.Checkout.showLoader( false );
					} else {
						setTimeout( function () {
							window.Cart.toggleCart( 'close' );
						}, 1500 );

						window.Cart.init();
					}
				},
			} );
		} );
	};

	FlexibleBundles.addBundle = () => {
		$( '.js-bundle-form' ).submit( ( e ) => {
			e.preventDefault();

			let data = {
				item: '',
				sections: [],
			},
				post = null,
				hasSelectedSizes = true;

			const $form = $( e.currentTarget ),
				$submit = $form.find( 'button[type=submit]' ),
				$submitText = $submit.find( '.js-button-text' );

			$submitText.text( $submit.data( 'text' ) );

			if ( isSinglePage ) {
				$( '.js-size-list' ).each( ( index, element ) => {
					if ( $( element ).find( 'input[type=radio]:checked' ).length === 0 ) {
						hasSelectedSizes = false;
					}
				} );
			}

			if ( !hasSelectedSizes ) {
				$submitText.text( $submit.data( 'error' ) );

				return;
			}

			$form
				.serializeArray()
				.forEach( ( item ) => {
					if ( item.name === 'item' ) {
						data.item = item.value;
					} else if ( item.name.indexOf( '-size' ) !== -1 ) {
						data.sections.push( {
							section: item.name.split( '-' )[1],
							item: item.value,
						} );
					} else if ( item.name === 'post' ) {
						post = item.value
					}
				} );

			$.ajax( {
				url: window.ajaxURL,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'add_bundle',
					post: post,
					data: data,
					esc_post: post,
					esc_product_item: data.item,
				},
				beforeSend: () => {
					$submit.addClass( 'is-loading' );
					$submit.prop( 'disabled', true );
				},
				error: ( data, textStatus ) => {
					console.log( data );
					console.log( textStatus );
				},
				success: ( result ) => {
					if ( result.success && result.data.cart ) {
						$cartItems.html( result.data.cart );
						window.Cart.toggleCart( 'open' );
					}
				},
				complete: () => {
					setTimeout( function () {
						window.Cart.toggleCart( 'close' );
						$submit.removeClass( 'is-loading' );
						$submit.prop( 'disabled', false );
					}, 1500 );

					window.Cart.init();
				},
			} );
		} );
	};

	FlexibleBundles.init = () => {
		FlexibleBundles.changeColor();
		FlexibleBundles.addBundle();
		FlexibleBundles.removeBundle();
	};

	FlexibleBundles.init();
} )( jQuery );


// WEBPACK FOOTER //
// ./scripts/components/bundles.js